(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  function trackAnnouncementHeight() {
    const bar = document.querySelector('.announcement-bar');
    if (!bar || bar.dataset.heightTracked) return;
    bar.dataset.heightTracked = 'true';
    const observer = new ResizeObserver(() => {
      if (window.matchMedia('(max-width: 1023px)').matches) {
        document.documentElement.style.setProperty('--announcement-height', bar.getBoundingClientRect().height + 'px');
      } else {
        document.documentElement.style.removeProperty('--announcement-height');
      }
    });
    observer.observe(bar);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === bar) observer.disconnect();
    });
  }
  trackAnnouncementHeight();
  document.addEventListener('shopify:section:load', trackAnnouncementHeight);

  } catch(e) { console.error(e); }
})();
})();
